unit UVmPosList;

interface

uses
  System.Contnrs, UVmPosModel, JS, UEssentialHelper, WebLib.ExtCtrls, UFakModel;

const
  VMPOSLISTKEY = 'VmPosList_';

type
  TVmPosList = class(TObjectList)
  private
    FOnListChanged: TCallback;
    FFak: TFakModel;
    FTimer: TTimer;
    FUrl: string;
    FOnError: TErrorEvent;
    FPersonalNr: string;
    FOnPropertyChanged: TPropertyChangedEvent;
    function GetItem(i: Integer): TVmPosModel;
    function GetNextNotTransmittedItem: TVmPosModel;
    function HasNotTransmittedItems: Boolean;
    procedure DoError(AMsg: string);
    procedure DoListChanged;
    procedure DoPropertyChanged(PropertyName: string);
    procedure HandlePropertyChanged(Sender: TObject; PropertyName: string);
    procedure Store;
    procedure TimerOnTime(Sender: TObject);
    procedure TransmitItem;
    procedure SetOnListChanged(const Value: TCallback);
    procedure SetFak(const Value: TFakModel);
    procedure SetOnError(const Value: TErrorEvent);
    procedure SetOnPropertyChanged(const Value: TPropertyChangedEvent);
  public
    constructor Create;
    function AreItemsSelected: Boolean;
    function IndexOf(Item: TVmPosModel): Integer;
    function ToJson: string;
    procedure Add(Item: TVmPosModel);
    procedure Delete(i: Integer);
    procedure GetAll;
    procedure Insert(i: Integer; Item: TVmPosModel);
    procedure Load;
    procedure SetValues(Json: string);
    procedure Sort;
    procedure StartTransmit;
    property Items[i: Integer]: TVmPosModel read GetItem;
    property OnListChanged: TCallback read FOnListChanged
      write SetOnListChanged;
    property OnError: TErrorEvent read FOnError write SetOnError;
    property Fak: TFakModel read FFak write SetFak;
    property PersonalNr: string read FPersonalNr write FPersonalNr;
    property Url: string read FUrl write FUrl;
    property OnPropertyChanged: TPropertyChangedEvent read FOnPropertyChanged
      write SetOnPropertyChanged;
  end;

implementation

uses
  WebLib.Json, System.SysUtils, WebLib.Storage, UStampModel, WebLib.REST,
  WebLib.Controls;

{ TVmPosList }

procedure TVmPosList.Add(Item: TVmPosModel);
begin
  Item.OnPropertyChanged := Self.HandlePropertyChanged;
  inherited Add(Item);
  Self.DoListChanged;
end;

function TVmPosList.AreItemsSelected: Boolean;
var
  i: Integer;
begin
  Result := false;
  i := 0;
  while not Result and (i < Self.Count) do
    if Self.Items[i].Selected then
      Result := true
    else
      Inc(i);
end;

constructor TVmPosList.Create;
begin
  inherited Create;
  Self.OnListChanged := nil;
  Self.OnError := nil;
  Self.OnPropertyChanged := nil;
  FTimer := TTimer.Create(nil);
  FTimer.Enabled := false;
  FTimer.Interval := 500;
  FTimer.OnTimer := Self.TimerOnTime;
end;

procedure TVmPosList.Delete(i: Integer);
begin
  inherited Delete(i);
  Self.DoListChanged;
end;

procedure TVmPosList.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TVmPosList.DoListChanged;
begin
  Self.Store;
  if Assigned(Self.OnListChanged) then
    Self.OnListChanged(Self);
end;

procedure TVmPosList.DoPropertyChanged(PropertyName: string);
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self, PropertyName);
end;

procedure TVmPosList.GetAll;
var
  obj: TJsonObject;
  s: string;
  client: TRestClient;
  procedure ErrorHandling(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Self.DoError('Verbindungsfehler!');
  end;

  procedure Response(Sender: TObject; AResponse: string);
  var
    jo: TJsObject;
  begin
    if AResponse <> '' then
    begin
      jo := TJsJson.parseObject(AResponse);
      if jo['value'] <> nil then
        Self.SetValues(string(jo['value']))
      else
        Self.DoError('JsonObject ''value'' fehlt in Response!');
    end
    else
      Self.DoError('Response-String ist leer!');
  end;

begin
  if Self.Fak <> nil then
  begin
    obj := TJsonObject.Create;
    obj.AddPair('FakId', IntToStr(Self.Fak.Id));
    s := obj.ToJson;
    obj := TJsonObject.Create;
    obj.AddPair('value', s);
    client := TRestClient.Create(nil);
    client.OnError := ErrorHandling;
    client.OnResponse := Response;
    client.HttpsPost(FUrl + '/StampService/GetVmPosList', 'application/json',
      obj.ToJson);
  end;
end;

function TVmPosList.GetItem(i: Integer): TVmPosModel;
begin
  Result := inherited GetItem(i) as TVmPosModel;
end;

function TVmPosList.GetNextNotTransmittedItem: TVmPosModel;
var
  i: Integer;
  found: Boolean;
begin
  i := 0;
  found := false;
  while not found and (i < Self.Count) do
    if Self.Items[i].TransmittedAt = 0 then
      found := true
    else
      Inc(i);
  if found then
    Result := Self.Items[i]
  else
    Result := nil;
end;

procedure TVmPosList.HandlePropertyChanged(Sender: TObject;
  PropertyName: string);
begin
  if PropertyName = 'Menge' then
  begin
    Self.Store;
    Self.DoListChanged;
  end;
  if PropertyName = 'Selected' then
    Self.DoPropertyChanged('Selected');
end;

function TVmPosList.HasNotTransmittedItems: Boolean;
var
  i: Integer;
begin
  i := 0;
  Result := false;
  while not Result and (i < Self.Count) do
    if Self.Items[i].TransmittedAt = 0 then
      Result := true
    else
      Inc(i);
end;

function TVmPosList.IndexOf(Item: TVmPosModel): Integer;
var
  i: Integer;
  found: Boolean;
begin
  i := 0;
  found := false;
  while not found and (i < Self.Count) do
    if Self.Items[i].Equals(Item) then
      found := true
    else
      Inc(i);
  if found then
    Result := i
  else
    Result := -1;
end;

procedure TVmPosList.Insert(i: Integer; Item: TVmPosModel);
begin
  Item.OnPropertyChanged := Self.HandlePropertyChanged;
  inherited Insert(i, Item);
  Self.DoListChanged;
end;

procedure TVmPosList.Load;
var
  s: string;
begin
  if (Self.Fak <> nil) and (Self.Fak.Nr <> '') and (Self.PersonalNr <> '') then
  begin
    s := TLocalStorage.GetValue(VMPOSLISTKEY + Self.Fak.Nr + '_' +
      Self.PersonalNr);
    if s <> '' then
      Self.SetValues(s)
    else
      Self.DoListChanged;
  end;
end;

procedure TVmPosList.SetFak(const Value: TFakModel);
begin
  FFak := Value;
end;

procedure TVmPosList.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TVmPosList.SetOnListChanged(const Value: TCallback);
begin
  FOnListChanged := Value;
end;

procedure TVmPosList.SetOnPropertyChanged(const Value: TPropertyChangedEvent);
begin
  FOnPropertyChanged := Value;
end;

procedure TVmPosList.SetValues(Json: string);
var
  obj: TJsObject;
  i, Count: Integer;
  dummy: TCallback;
begin
  dummy := Self.OnListChanged;
  Self.OnListChanged := nil;
  Self.Clear;
  obj := TJsJson.parseObject(Json);
  if obj['Count'] <> nil then
  begin
    Count := StrToInt(string(obj['Count']));
    for i := 0 to Count - 1 do
      if obj['Item' + IntToStr(i)] <> nil then
        Self.Add(TVmPosModel.Create(string(obj['Item' + IntToStr(i)])));
  end;
  Self.OnListChanged := dummy;
  Self.DoListChanged;
end;

procedure TVmPosList.Sort;
var
  i, j: Integer;
begin
  if Self.Count > 1 then
  begin
    for i := 0 to Self.Count - 1 do
      for j := 0 to Self.Count - 2 do
        if Self.Items[j].CreatedAt < Self.Items[j + 1].CreatedAt then
          Self.Exchange(j, j + 1);
  end;
  Self.DoListChanged;
end;

procedure TVmPosList.StartTransmit;
begin
  FTimer.Enabled := true;
end;

procedure TVmPosList.Store;
begin
  if (Self.Fak <> nil) and (Self.Fak.Nr <> '') and (Self.PersonalNr <> '') then
    TLocalStorage.SetValue(VMPOSLISTKEY + Self.Fak.Nr + '_' + Self.PersonalNr,
      Self.ToJson);
end;

procedure TVmPosList.TimerOnTime(Sender: TObject);
begin
  FTimer.Enabled := false;
  if Self.HasNotTransmittedItems then
    Self.TransmitItem;
end;

function TVmPosList.ToJson: string;
var
  obj: TJsonObject;
  i: Integer;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Count', IntToStr(Self.Count));
  for i := 0 to Self.Count - 1 do
    obj.AddPair('Item' + IntToStr(i), Self.Items[i].ToJson);
  Result := obj.ToJson;
  obj.Free;
end;

procedure TVmPosList.TransmitItem;
var
  Item: TVmPosModel;
  stamp: TStampModel;
  procedure SuccessHandling(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      stamp := Sender as TStampModel;
      Item.TransmittedAt := now;
      Self.Store;
      if Self.HasNotTransmittedItems then
        FTimer.Enabled := true;
    end;
  end;
  procedure ErrorHandling(Sender: TObject; AMsg: string);
  begin
    FTimer.Enabled := true;
  end;

begin
  Item := Self.GetNextNotTransmittedItem;
  if Item <> nil then
  begin
    stamp := TStampModel.Create;
    stamp.PersonalNr := Item.PersonalNr;
    stamp.Art := 'VM';
    stamp.Zeitpunkt := Item.CreatedAt;
    stamp.Fak := Self.Fak;
    stamp.Mat := Item.Mat;
    stamp.Menge := Item.Menge;
    stamp.OnPropertyChanged := SuccessHandling;
    stamp.OnError := ErrorHandling;
    stamp.Insert(FUrl);
  end;
end;

end.
